import { getDownloadURL, listAll, ref as storageRef } from "firebase/storage";
import { isFirebaseConfigured, storage } from "@/lib/firebase";

const IMAGE_FILE_PATTERN = /\.(avif|gif|jpe?g|png|svg|webp)$/i;

const compareByName = (left, right) =>
  left.name.localeCompare(right.name, undefined, {
    numeric: true,
    sensitivity: "base",
  });

export const listStorageImageUrls = async (folderPath) => {
  if (!isFirebaseConfigured || !storage || !folderPath) {
    return [];
  }

  const result = await listAll(storageRef(storage, folderPath));
  const images = result.items.filter((item) => IMAGE_FILE_PATTERN.test(item.name));

  return Promise.all(
    images.sort(compareByName).map((item) => getDownloadURL(item))
  );
};

export const getStorageFileUrl = async (filePath) => {
  if (!isFirebaseConfigured || !storage || !filePath) {
    return "";
  }

  return getDownloadURL(storageRef(storage, filePath));
};
